import { logout } from '@/utils/auth';
import { postJson } from '@/utils/fetchOptions';

import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuthToken, useMutation } from '..';

interface UseCollaborationUpdateProps {
  chosenPublishDates: {
    beat_id: string;
    date_publish: Date | string;
  }[];
  collaborationId: string;
  onSuccess: TypeAny;
}

export function useCollaborationUpdate({
  chosenPublishDates,
  collaborationId,
  onSuccess
}: UseCollaborationUpdateProps) {
  const token = useAuthToken();
  const { t } = useTranslation();

  const { isLoading, mutate, error, data } = useMutation({
    mutationKey: `influencer-collaboration-update-${collaborationId}`,
    mutationFn: async () =>
      postJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/collaboration/${collaborationId}/update`,
        body: { chosen_dates_publish: chosenPublishDates },
        token
      }).then((response: ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          message.success(t(`alert.${response.code}`));
        }

        return response;
      }),
    onSuccess
  });

  return {
    data: data || {},
    isLoading,
    mutate,
    error
  };
}
